import useVirtualAppointmentGql from './useVirtualAppointmentGql';
import ensureInputHash from '../../../../../../base/utils/ensureInputHash';
import useNotificationStateContext from '../../../../../../base/hooks/useNotificationStateContext';
import useVirtualAppointmentContext from './useVirtualAppointmentContext';

const useVirtualAppointmentFormMutation = () => {
  const { useVirtualAppointmentMutation } = useVirtualAppointmentGql();
  const [mutation] = useVirtualAppointmentMutation();
  const { triggerNotification } = useNotificationStateContext();
  const { setStep } = useVirtualAppointmentContext();

  const mutate = (input) => {
    mutation({ variables: { input: ensureInputHash(input) } })
      .then((response) => {
        const { data } = response;
        if (data.errors) {
          triggerNotification(data.errors, 'error');
        } else if (data.createVaLead) {
          triggerNotification('Request submitted!');
          setStep(3);
        }
      });
    return false;
  };
  return {
    mutate,
  };
};

export default useVirtualAppointmentFormMutation;
